import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../../headersService";


export const getPublicAnnouncements = createAsyncThunk('getDriveAnnouncements', async (driveId, { rejectWithValue }) => {
    try {
        const { data } = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/announcement`)
        return data
    } catch (error) {
        console.log(error)
        return rejectWithValue(error)
    }
})

export const getPublicAnnouncementSlice = createSlice({
    name: 'Announcements',
    initialState: {
        loading: false,
        announcements: [],
        error: null
    },
    extraReducers: (builder) => {
        builder.addCase(getPublicAnnouncements.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getPublicAnnouncements.fulfilled, (state, action) => {
            state.loading = false;
            state.announcements = action.payload
        })
        builder.addCase(getPublicAnnouncements.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        })
    }
})
export default getPublicAnnouncementSlice.reducer